import { render, staticRenderFns } from "./GoodItem.vue?vue&type=template&id=53a3c8c6&scoped=true&"
import script from "./GoodItem.vue?vue&type=script&lang=ts&"
export * from "./GoodItem.vue?vue&type=script&lang=ts&"
import style0 from "./GoodItem.vue?vue&type=style&index=0&id=53a3c8c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a3c8c6",
  null
  
)

export default component.exports